import { API_BASE_URL } from '../config';

export interface SupplierFinderRequest {
  product: string;
  location: string;
  userId: string;
}

export interface Supplier {
  name: string;
  description: string;
  contactInfo?: string;
  website?: string;
  location: string;
}

export interface SupplierFinderResponse {
  suppliers: Supplier[];
}

/**
 * Find trade suppliers for products or services in a specific location
 */
export const findSuppliers = async (request: SupplierFinderRequest): Promise<SupplierFinderResponse> => {
  try {
    // Ensure there are no spaces in the URL by using URL constructor
    const url = new URL('/api/suppliers/find', API_BASE_URL.includes('://') ? API_BASE_URL : 'http://localhost:5000');
    const response = await fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });
    
    if (!response.ok) {
      throw new Error(`Error finding suppliers: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error finding suppliers:', error);
    throw error;
  }
};
